"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const stimulus_1 = require("@hotwired/stimulus");
require("lightgallery/css/lightgallery.css");
require("lightgallery/css/lg-video.css");
const lightgallery_1 = __importDefault(require("lightgallery"));
const video_1 = __importDefault(require("lightgallery/plugins/video"));
class default_1 extends stimulus_1.Controller {
    connect() {
        const boatGallerySelector = "[data-boat-gallery-item]";
        const hasBoatGalleryItems = this.element.querySelector(boatGallerySelector);
        this.primeVideoPreviews();
        (0, lightgallery_1.default)(this.element, {
            plugins: [video_1.default],
            speed: 0,
            // Boat media uses a dedicated attribute so nested guest-photo galleries
            // are not pulled into this lightbox. Guest galleries keep Stimulus targets.
            selector: hasBoatGalleryItems
                ? boatGallerySelector
                : this.galleryItemTargets,
            autoplayFirstVideo: false,
            autoplayVideoOnSlide: false,
            // lightGallery defaults YouTube/Vimeo embeds to muted; boat videos should play with sound.
            youTubePlayerParams: {
                mute: 0,
            },
            vimeoPlayerParams: {
                muted: 0,
            },
        });
    }
    /**
     * When no custom thumbnail exists, nudge muted preview videos off frame 0
     * so browsers paint a visible first frame (same idea as Ahoy Days).
     */
    primeVideoPreviews() {
        this.element
            .querySelectorAll("[data-gallery-video-preview]")
            .forEach((video) => {
            const seekPreviewFrame = () => {
                if (video.currentTime >= 0.05) {
                    return;
                }
                try {
                    video.currentTime = 0.1;
                }
                catch (_a) {
                    // Some browsers block seeking before enough data is buffered.
                }
            };
            if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
                seekPreviewFrame();
                return;
            }
            video.addEventListener("loadeddata", seekPreviewFrame, { once: true });
        });
    }
}
exports.default = default_1;
default_1.targets = ["galleryItem"];
